import * as tslib_1 from "tslib";
import MailView from './MailView';
import { observer } from 'mobx-react';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import { GroupFavoriteButton } from 'owa-group-favorite-button';
import { LazyGroupFilesHub, LazyGroupFilesHubSxSLayerView } from 'owa-group-files-hub-view';
import groupHeaderCommandBarStore from 'owa-group-header-store/lib/store/CommandBarStore';
import GroupHeaderNavigationButton from 'owa-group-header-store/lib/store/schema/NavigationButton';
import { GroupHeader } from 'owa-group-header-view';
import { lazyOpenGroupSettings } from 'owa-group-settings-integration';
import { lazyIsJoinedGroup } from 'owa-group-utils';
import * as React from 'react';
var commonStyles = require('./MailModule.scss');
var styles = require('./GroupView.scss');
var GroupView = /** @class */ (function (_super) {
    tslib_1.__extends(GroupView, _super);
    function GroupView(props) {
        var _this = _super.call(this, props) || this;
        _this.openGroupSettings = function (groupId) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var openGroupSettings;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, lazyOpenGroupSettings.import()];
                    case 1:
                        openGroupSettings = _a.sent();
                        openGroupSettings(groupId);
                        return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    GroupView.prototype.render = function () {
        var renderFavoriteButton = null;
        if (isControlFeatureEnabled('tri-favorites-roaming')) {
            renderFavoriteButton = function (groupId) {
                var isJoinedGroup = lazyIsJoinedGroup.tryImportSync();
                return (isJoinedGroup &&
                    isJoinedGroup(groupId) && (React.createElement(GroupFavoriteButton, { iconStyles: styles.favoriteButtonInHeader, groupId: groupId })));
            };
        }
        return (React.createElement("div", { className: commonStyles.rightPane },
            React.createElement("div", { className: commonStyles.groupHeaderOuter },
                React.createElement(GroupHeader, { renderFavoriteButton: renderFavoriteButton, openGroupSettings: this.openGroupSettings })),
            this.renderSelectedGroupView()));
    };
    GroupView.prototype.renderSelectedGroupView = function () {
        var currentView = groupHeaderCommandBarStore.navigationButtonSelected;
        switch (currentView) {
            case GroupHeaderNavigationButton.Email:
                return React.createElement(MailView, tslib_1.__assign({}, this.props));
            case GroupHeaderNavigationButton.Files:
                return (React.createElement("div", { className: styles.wrapper },
                    React.createElement(LazyGroupFilesHub, { className: styles.fileshub }),
                    React.createElement(LazyGroupFilesHubSxSLayerView, null)));
                break;
            // TODO: add all other cases here
        }
        return null;
    };
    GroupView = tslib_1.__decorate([
        observer
    ], GroupView);
    return GroupView;
}(React.Component));
export default GroupView;
//# sourceMappingURL=GroupView.js.map